export default IconOverline => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-overline" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 9v5a5 5 0 0 0 10 0v-5" />
  <path d="M5 5h14" />
</svg>`;